module.exports = __webpack_public_path__ + "static/media/Chris_Vermilya.c797e234.jpg";